import React, { useState } from 'react';
import styled from 'styled-components';
import useMetronome from '../utility/useMetronome';
import HamQuest from '../api/HamQuestGiver';
import { QuestRoute } from '../api/QuestRoutes';
import Title from '../forms/Title';
import Heading from '../forms/Heading';
import Col from '../layout/Col';
import Icon from '../forms/Icon';

const Wrapper = styled.div`
    position: relative;
    display: flex;
    // width: 100%;
    padding: 1em;
    color:  ${({ theme }) => theme.white};
    margin-bottom: 1em;
    background: ${({ theme }) => theme.secondary}b3;
    border-radius: 1em;

    box-shadow: inset 1px 6px 12px ${({ theme }) => theme.secondary}5c, inset -1px -10px 5px ${({ theme }) => theme.secondary}, 1px 2px 3px black;
    text-shadow: 1px 1px 1px black;
`

const Banner = ({ }) => {

    const [data, setData] = useState([]);
    const [fetchData, setFetchData] = useState(10);

    useMetronome(() => {
        if (fetchData > 0) {
            setFetchData(fetchData - 1)
            HamQuest.get(QuestRoute.dashboard.washCount)
                .then(res => setData(res))
                .catch(ex => console.error(ex))
        }
    }, 60000)

    return (
        <Wrapper>
            <Col>
                <span>Car Washes <Icon icon='car' /></span>
                <span>Today: {data.today}</span>
                <span>Yesterday: {data.yesterday}</span>
            </Col>

        </Wrapper>
    );
}

export default Banner;
